// @ts-strict-ignore
import { useLocation } from 'react-router';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsApiSubsite } from 'modules/cms/api/types/CmsApiSubsite';

type Props = {
  cmsApiPage: CmsApiPage | undefined;
};

type ContentSubsiteLocationState = {
  subsite: CmsApiSubsite;
};

export function useCmsApiPageSubsite({
  cmsApiPage,
}: Props): CmsApiSubsite | undefined {
  const location = useLocation();
  const state = location.state as ContentSubsiteLocationState;

  return state && state.subsite
    ? {
        ...state.subsite,
        defaultSearchType: cmsApiPage.subsite.defaultSearchType,
      }
    : cmsApiPage && cmsApiPage.subsite;
}
